import React, { useEffect } from 'react';

const Modal = ({ 
    isOpen, 
    onClose, 
    children, 
    width = "sm:max-w-lg",
    bgColor = "bg-black/30",
    blurLevel = "",
    modalBgColor = "bg-white",
    shadow = "shadow-xl"
}) => {
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [isOpen]);

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 overflow-y-auto">
            <div className="flex items-center justify-center min-h-screen">
                {/* Background overlay */}
                <div className="fixed inset-0 transition-opacity" aria-hidden="true">
                    <div className={`absolute inset-0 ${bgColor} ${blurLevel}`}></div>
                </div>

                {/* Modal panel */}
                <div className={`relative ${modalBgColor} rounded-lg text-left overflow-hidden ${shadow} transform transition-all ${width} w-full`}>
                    {/* Close button - moved outside content area */}
                    <div className="absolute top-0 right-0 pt-4 pr-4 z-10">
                        <button
                            type="button"
                            className="bg-white/80 hover:bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none"
                            onClick={onClose}
                        >
                            <span className="sr-only">Close</span>
                            <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>

                    {/* Modal content - added padding-top to prevent overlap */}
                    <div className={`${modalBgColor} px-4 pt-12 pb-4 sm:p-6 sm:pt-12`}>
                        <div className="mt-3 sm:mt-0 sm:text-left">
                            {children}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Modal;